/* eslint-disable no-async-promise-executor */
import config from '../config'

const md5 = require('md5')

const checkRole = (user_type) => {
  let allowed_resources_names = []
  if (user_type.includes('Admin')) {
    allowed_resources_names = allowed_resources_names.concat([
      'home',
      'tickets_gestionnaire',
      'tickets_processowner',
      'dashboard_copromanager',
      'letters',
      'file_with_context',
      // Tickets menu
      'tickets',
      'tickets_archived',
      'tickets_drafts',
      'prestas',
      // Copros menu
      'copros',
      'copros_fiche',
      'contracts',
      'ags1a',
      'copros_general_news',
      // Finance
      'invoices1',
      'co_owner_balances',
      'co_owner_balances_properties',
      'sepa_1',
      'sepa_2',
      'budget_compliance',
      // Courrier
      'send-letter',
      'letters_followup',
      // Clients
      'massmails',
      'contacts',
      'coproprietaires',
      // Tooling
      'transferable_users',
      'incoming_calls',
      'new_quotation',
      'transferts_status',
      'new_caretaker_contract',
      'hr_docs_to_sign',
      'divers_docs_to_sign',
      // Kpis
      'data_kpis',
      // Compliance
      'compliance/bank_account',
      'compliance/assurance',
      'compliance/syndic_contracts',
      'compliance/lots',
      'compliance/access',
      'compliance/janitor',
      'compliance/coownership_rules',
      'compliance/ag',
      'compliance/visits_remaining',
      'compliance/visits_global',
      // Settings
      'process',
      'tags',
      'ai_monitoring',
      'global_vars',
      'emails_unknown',
      'users',
      'routing_config',
      'routing_keywords',
      'routing_ai_keywords',
      'releases',
      'report_error',
    ])
  } else if (
    user_type.includes('Contrat') ||
    'Comptable Universal' === user_type
  ) {
    allowed_resources_names = allowed_resources_names.concat([
      'prestas',
      'copros_fiche',
      'contracts',
      'send-letter',
      'letters_followup',
      'routing_rules',
    ])
  } else if (user_type.includes('Guest')) {
    allowed_resources_names = []
  } else {
    allowed_resources_names = allowed_resources_names.concat([
      'home',
      'tickets_gestionnaire',
      'tickets_processowner',
      'dashboard_copromanager',
      'dashboard_copromanager_new',
      'file_with_context',
      // Tickets menu
      'tickets',
      'tickets_drafts',
      'prestas',
      // Copros menu
      'copros',
      'copros_fiche',
      'ags1a',
      'contracts',
      'copros_general_news',
      // Finance
      'invoices1',
      'co_owner_balances',
      'co_owner_balances_properties',
      'sepa_1',
      'sepa_2',
      'budget_compliance',
      // Courrier
      'send-letter',
      'letters_followup',
      // Clients
      'massmails',
      'contacts',
      'coproprietaires',
      // Tooling
      'transferable_users',
      'incoming_calls',
      'new_quotation',
      'transferts_status',
      'new_caretaker_contract',
      'hr_docs_to_sign',
      'divers_docs_to_sign',
      // Kpis
      'data_kpis',
      // Compliance
      'compliance/bank_account',
      'compliance/assurance',
      'compliance/syndic_contracts',
      'compliance/lots',
      'compliance/access',
      'compliance/janitor',
      'compliance/coownership_rules',
      'compliance/ag',
      'compliance/visits_remaining',
      'compliance/visits_global',
    ])
  }

  // Maybe is a good idea to move this into db in the future
  return allowed_resources_names
}

const fetchProfile = () => {
  return new Promise(async (resolve, reject) => {
    let request = new Request(`${config.API_V1}/users/-1`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      json: true,
    })
    await fetch(request)
      .then((response) => {
        return response.json()
      })
      .then(({ user_type, id, email, firstname, lastname }) => {
        if (!user_type) {
          reject()

          return
        }

        var profile = { id, fullName: `${firstname} ${lastname}`, email }
        localStorage.setItem('auth', JSON.stringify(profile))

        request = new Request(`https://en.gravatar.com/${md5(email)}.json`, {
          method: 'GET',
          headers: new Headers({ 'Content-Type': 'application/json' }),
          json: true,
        })

        fetch(request)
          .then((response) => {
            return response.json()
          })
          .then(({ entry }) => {
            if (entry) {
              profile.avatar = entry[0].thumbnailUrl
            }
            localStorage.setItem('auth', JSON.stringify(profile))
            resolve(JSON.stringify(profile))
          })
          .catch((error) => resolve(JSON.stringify(profile)))
      })
  })
}

const isExtranet = (url) => {
  return (
    url.indexOf('ext') != -1 ||
    url.indexOf('extranet') != -1 ||
    url.indexOf('frontplugin') != -1 ||
    url.indexOf('zendesk_plugin') != -1 ||
    url.indexOf('pvags') != -1
  )
}
const isUnauthorized = (url) => {
  return (
    url.indexOf('unauthorized') != -1 || url.indexOf('account_disabled') != -1
  )
}

export default {
  login: () => {
    if (isExtranet(window.location.href)) {
      return Promise.resolve()
    }
    window.location.href = '/oauth2/sign_in'
  },
  logout: () => {
    if (isExtranet(window.location.href)) {
      return Promise.resolve()
    }

    localStorage.removeItem('auth')
    localStorage.removeItem('user_type')
    window.location.href = `${window.location.origin}/oauth2/sign_in`
  },
  checkError: (error) => {
    const status = error?.status
    if (status === 401) {
      // CHECK IF UNAUTHORIZED REDIRCT TO LOGIN
      window.location.href = '/oauth2/sign_in'
    }
    return Promise.resolve()
  },
  checkAuth: () =>
    new Promise(async (resolve, reject) => {
      if (isExtranet(window.location.href)) {
        resolve()

        return
      }
      const request = new Request(`${config.APP_URL}/oauth2/auth`, {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        json: true,
      })
      await fetch(request)
        .then((response) => {
          if (response.status === 202) {
            // localStorage.setItem("email", response.headers.get('x-auth-request-email'));
            resolve()

            return
          }
          localStorage.clear()
          reject()
        })
        .catch(() => {
          localStorage.clear()
          reject()
        })
    }),
  getPermissions: () =>
    new Promise(async (resolve, reject) => {
      if (
        isExtranet(window.location.href) ||
        isUnauthorized(window.location.href)
      ) {
        resolve()

        return
      }
      const user_type_storage = localStorage.getItem('user_type')
      if (user_type_storage) {
        resolve(checkRole(user_type_storage))
      }
      const request = new Request(`${config.API_V1}/users/-1`, {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        json: true,
      })
      const response = await fetch(request)
      const data = await response.json()
      if (!response.ok && response.status == 401) {
        window.location.href = '/unauthorized'
        return
      } else if (!response.ok && response.status == 403) {
        window.location.href = '/account_disabled'
        return
      }
      if (!data.user_type) {
        reject()
        return
      }
      window.context['user_type'] = data.user_type
      localStorage.setItem('user_type', data.user_type)
      resolve(checkRole(data.user_type))
    }),
  getIdentity: () =>
    new Promise((resolve, reject) => {
      if (isExtranet(window.location.href)) {
        resolve()

        return
      }
      try {
        if (
          !localStorage.getItem('auth') ||
          localStorage.getItem('auth') == '{}'
        ) {
          fetchProfile()
            .then(() => {
              const { id, fullName, avatar, email } = JSON.parse(
                localStorage.getItem('auth')
              )
              resolve({ id, fullName, avatar, email })
            })
            .catch((error) => {
              return reject(error)
            })
        } else {
          const { id, fullName, avatar, email } = JSON.parse(
            localStorage.getItem('auth')
          )
          return resolve({ id, fullName, avatar, email })
        }
      } catch (error) {
        return reject(error)
      }
    }),
}
